/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable operator-linebreak */
import React, { createContext, useContext, useState } from 'react';
import { EmployeeReviewType } from 'src/services/approvals.service';

interface IEmployeeReviewChangesContext {
  currentEmployeeReviewType: EmployeeReviewType | {};
  reviewModalIsOpen: boolean;
  // eslint-disable-next-line no-unused-vars
  setReviewModalIsOpen: (b: boolean) => void;
  // eslint-disable-next-line no-unused-vars
  setCurrentEmployeeReviewType: (v: EmployeeReviewType) => void;
}

const employeeReviewChangesContext = (): IEmployeeReviewChangesContext => {
  const [reviewModalIsOpen, setReviewModalIsOpen] = useState(false);
  const [currentEmployeeReviewType, setCurrentEmployeeReviewType] = useState({});

  return {
    reviewModalIsOpen,
    setReviewModalIsOpen,
    currentEmployeeReviewType,
    setCurrentEmployeeReviewType,
  };
};

const EmployeeReviewChangesContext = createContext<IEmployeeReviewChangesContext | null>(null);

export const EmployeeReviewChangesContextProvider: React.FC = ({ children }) => (
  <EmployeeReviewChangesContext.Provider value={employeeReviewChangesContext()}>
    {children}
  </EmployeeReviewChangesContext.Provider>
);

export const useReviewModalIsOpen = (): boolean => useContext(EmployeeReviewChangesContext)?.reviewModalIsOpen || false;

// eslint-disable-next-line no-unused-vars
export const useSetReviewModalIsOpen = (): ((b: boolean) => void) =>
  useContext(EmployeeReviewChangesContext)?.setReviewModalIsOpen ?? (() => {});

export const useCurrentEmployeeReviewType = (): EmployeeReviewType | {} =>
  useContext(EmployeeReviewChangesContext)?.currentEmployeeReviewType ?? {};

export const useSetCurrentEmployeeReviewType = (): ((
  // eslint-disable-next-line no-unused-vars
  b: EmployeeReviewType
) => void) => useContext(EmployeeReviewChangesContext)?.setCurrentEmployeeReviewType ?? (() => {});
